import { render, staticRenderFns } from "./MyDeviceItem.vue?vue&type=template&id=679ea272&scoped=true&"
import script from "./MyDeviceItem.vue?vue&type=script&lang=js&"
export * from "./MyDeviceItem.vue?vue&type=script&lang=js&"
import style0 from "./MyDeviceItem.vue?vue&type=style&index=0&id=679ea272&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "679ea272",
  null
  
)

export default component.exports